import { FadeUp } from "./Reveal";
import { useI18n } from "@/context/Language";

const spans = ["sm:col-span-2 sm:row-span-2", "sm:col-span-1", "sm:col-span-1", "sm:col-span-1", "sm:col-span-1", "sm:col-span-2"];

export const Gallery = () => {
  const { t } = useI18n();
  const images = t.galleryImg;
  const captions = t.gallery.captions;

  return (
    <section id="gallery" className="relative py-24 sm:py-32 bg-sand-2 border-y border-border-soft">
      <div className="max-w-7xl mx-auto px-6 sm:px-8">
        <FadeUp>
          <div className="flex items-end justify-between flex-wrap gap-4">
            <div className="max-w-xl">
              <span className="text-xs uppercase tracking-[0.24em] text-terracotta">{t.gallery.overline}</span>
              <h2 className="mt-4 font-serif text-4xl sm:text-5xl tracking-tight text-ink">{t.gallery.heading}</h2>
            </div>
            <p className="text-sm text-ink/50 max-w-xs">{t.gallery.intro}</p>
          </div>
        </FadeUp>

        <div className="mt-14 grid grid-cols-2 sm:grid-cols-3 gap-3 sm:gap-4 auto-rows-[180px] sm:auto-rows-[220px]">
          {images.map((src, i) => (
            <FadeUp key={i} delay={(i % 3) * 0.08} className={`group relative overflow-hidden border border-border-soft ${spans[i % spans.length]}`}>
              <img src={src} alt={captions[i]} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105" />
              <div className="absolute inset-0 bg-gradient-to-t from-ink/85 via-ink/25 to-transparent" />
              <span className="absolute bottom-3 left-4 right-4 text-sm font-medium leading-snug text-sand">{captions[i]}</span>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
